import dayjs from 'dayjs';
import isEqual from 'lodash/isEqual';

export default {
  name: 'OrderSearch',
  props: {
    dates: {
      default: () => [],
      type: Array,
    },
    dateType: {
      default: 'start',
      type: String,
      validator: (val) => ['receive', 'start'].includes(val),
    },
    loading: {
      default: false,
      type: Boolean,
    },
    value: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      openedFilter: false,
      selectedDates: [],
      type: 'start',
    };
  },
  computed: {
    isSubmitDisabled() {
      return !this.value && !this.selectedDates?.length;
    },
    maxDate() {
      return dayjs(this.getPeriodWith('month').end).toDate();
    },
    minDate() {
      return dayjs().subtract(2, 'year').toDate();
    },
  },
  methods: {
    dateFormatter(arr) {
      return arr.map((time) => this.formatTime(time, 'YYYY/MM/DD')).join(' - ');
    },
    formatTime(time, format = 'YYYY-MM-DD') {
      return dayjs(time).format(format);
    },
    getPeriodWith(period = 'month', date = dayjs()) {
      return {
        end: date.endOf(period),
        start: date.startOf(period),
      };
    },
    onSearch() {
      this.$emit('search');
    },
  },
  watch: {
    dates(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.selectedDates = newVal;
      }
    },
    dateType(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.type = newVal;
      }
    },
    selectedDates(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('updated-dates', newVal);
      }
    },
    type(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.$emit('updated-date-type', newVal);
      }
    },
  },
};
